module.exports = __webpack_public_path__ + "resource/typeface/element-icons.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.ttf?t=1510834658947
// module id = 226
// module chunks = 36